import { render, staticRenderFns } from "./CertificateType.vue?vue&type=template&id=432789a4"
import script from "./CertificateType.vue?vue&type=script&lang=js"
export * from "./CertificateType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports